define(function (require, exports, module) {
    'use strict';

    var UploadFail = require('./UploadFail');

    /**
     * @constructor
     * @extends {UploadFail}
     * @param {Error} stack
     * @param {string} source
     */
    function ConnectionFail(stack, source) {
        UploadFail.apply(this, arguments);
    }

    ConnectionFail.CONNECTION_FAILURE = 0;

    ConnectionFail.prototype = Object.assign(Object.create(UploadFail.prototype), {
        constructor: ConnectionFail,
        className: 'ConnectionFail',
        radarName: 'fail_{SOURCE}_connection',
        message: 'Разрыв соединения.',
    });

    module.exports = ConnectionFail;
});
